import { z } from 'zod';
import { Division, ProjectModel, ProjectStatus, RiskLevel } from '../enums.js';
const isoDate = z.string().datetime().or(z.string().regex(/^\d{4}-\d{2}-\d{2}$/));
export const projectMemberInput = z.object({
    userId: z.string().optional().nullable(),
    supplierId: z.string().optional().nullable(),
    role: z.string().min(1).max(100),
    hourlyRate: z.coerce.number().min(0).max(10000),
    hoursPlanned: z.coerce.number().int().min(0).default(0),
    isInternal: z.boolean().default(true),
});
export const milestoneInput = z.object({
    label: z.string().min(1).max(120),
    dueDate: isoDate,
    done: z.boolean().default(false),
    active: z.boolean().default(false),
    order: z.coerce.number().int().min(0).default(0),
});
export const createProjectInput = z.object({
    code: z.string().min(3).max(20).optional(), // se omesso, auto-generato
    name: z.string().min(1).max(200),
    clientId: z.string(),
    // La trattativa da cui nasce il progetto. Facoltativo: un progetto può non
    // avere alle spalle nessuna trattativa (lavori interni, piccoli interventi
    // sui clienti storici). Quando c'è, quel valore esce dal potenziale
    // commerciale ed entra nel progetto: non si conta due volte.
    dealId: z.string().optional().nullable(),
    division: z.nativeEnum(Division),
    model: z.nativeEnum(ProjectModel),
    status: z.nativeEnum(ProjectStatus).default(ProjectStatus.PREVENTIVO),
    phase: z.string().max(100).default('Preventivo'),
    progress: z.coerce.number().int().min(0).max(100).default(0),
    pmId: z.string().optional().nullable(),
    startDate: isoDate.optional().nullable(),
    deadline: isoDate.optional().nullable(),
    endDate: isoDate.optional().nullable(),
    revenue: z.coerce.number().min(0).default(0),
    cost: z.coerce.number().min(0).default(0),
    riskLevel: z.nativeEnum(RiskLevel).default(RiskLevel.LOW),
    marginThreshold: z.coerce.number().min(0).max(100).default(20),
    repositoryUrl: z.string().url().optional().nullable().or(z.literal('')),
    stagingUrl: z.string().url().optional().nullable().or(z.literal('')),
    // Note interne: da dove vengono i numeri e, soprattutto, cosa NON sappiamo.
    // Un campo lasciato vuoto senza una spiegazione sembra una dimenticanza;
    // qui si scrive perché è vuoto.
    notes: z.string().max(4000).optional().nullable(),
    tags: z.array(z.string()).default([]),
    members: z.array(projectMemberInput).default([]),
    milestones: z.array(milestoneInput).default([]),
});
export const updateProjectInput = createProjectInput.partial();
export const projectListItemDTO = z.object({
    id: z.string(),
    code: z.string(),
    name: z.string(),
    client: z.object({ id: z.string(), legalName: z.string(), shortName: z.string() }),
    division: z.nativeEnum(Division),
    model: z.nativeEnum(ProjectModel),
    status: z.nativeEnum(ProjectStatus),
    phase: z.string(),
    progress: z.number(),
    pm: z.object({ id: z.string(), firstName: z.string(), lastName: z.string(), initials: z.string() }).nullable(),
    deadline: z.string().nullable(),
    revenue: z.number(),
    cost: z.number().optional(), // gated
    marginPct: z.number().optional(),
    marginAbs: z.number().optional(),
    riskLevel: z.nativeEnum(RiskLevel),
    tasksOpen: z.number().int(),
    tasksDone: z.number().int(),
    hasAlert: z.boolean(),
});
//# sourceMappingURL=project.js.map